import { useShouldImport } from '@/vdp/VehicleDetailsContainer/hooks';
import {
  useGetIsWIPVehicle,
  useIsNewVehicle
} from '~/context/vdp/VehicleContext';

export default function useShowInspection() {
  const { importRecalls } = useShouldImport();
  const isNewVehicle = useIsNewVehicle();
  const isWIPVehicle = useGetIsWIPVehicle();

  return !isWIPVehicle && (!isNewVehicle || importRecalls);
}
